module.exports = __webpack_public_path__ + "img/开启关闭历史文件.780733f1.svg";